/** Central API base URLs and paths used by registration & solar seller flows. */

export const API_BASE_V2 = 'https://www.admin.infrioindia.com/api/v2';

export const AUTH_API_BASE = `${API_BASE_V2}/auth`;

export const AUTH_ENDPOINTS = {
  LOGIN: `${AUTH_API_BASE}/login`,
  REGISTER: `${AUTH_API_BASE}/register`,
  VERIFY_EMAIL: `${AUTH_API_BASE}/verify-email`,
  RESEND_OTP: `${AUTH_API_BASE}/resend-otp`,
  BLOG_LIST: `${AUTH_API_BASE}/blog-list`,
  BLOG_DETAILS: `${AUTH_API_BASE}/blog-details`,
  FORGOT_PASSWORD: `${AUTH_API_BASE}/forgot-password`,
  CHANGE_PASSWORD: `${AUTH_API_BASE}/change-password`,
  INQUERY_FORM_STORE: `${AUTH_API_BASE}/inquiry-form-store`
};

export const SOLAR_API_BASE = `${API_BASE_V2}/property`;
export const STAFF_PROFILE_API_BASE = `${API_BASE_V2}/solar`;
export const SOLAR_PAYMENT_API_BASE = `${API_BASE_V2}/solar/payment`;

export const SOLAR_ENDPOINTS = {
  INQUERY_STORE: `${SOLAR_API_BASE}/properties/inquiry/store`,
  CONTACT_US: `${SOLAR_API_BASE}/contact-us/submit`,
  INQUERY_GET: `${SOLAR_API_BASE}/properties/inquiry/get`,
  INQUERY_USER_GET: `${SOLAR_API_BASE}/inquery/user/get`,
  INQUERY_DETAILS: `${SOLAR_API_BASE}/inquery/detail`,
  INQUERY_FOLLOW_UP_STORE: `${SOLAR_API_BASE}/inquery/follow-up/store`,
  INQUERY_FOLLOW_UP_UPDATE: `${SOLAR_API_BASE}/inquery/follow-up/update`,
  INQUERY_ASSIGN_STAFF: `${SOLAR_API_BASE}/inquery/assign-staff`,
  INQUERY_UNDER_DISCUSSION: `${SOLAR_API_BASE}/inquery/under-discussion`,
  INQUERY_CONVERT: `${SOLAR_API_BASE}/inquery/convert`,
  INQUERY_CONVERTED_STORE: `${SOLAR_API_BASE}/converted-inquery/store`,
  INQUERY_CONVERTED_UPDATE: `${SOLAR_API_BASE}/converted-inquery/update`,
  INQUERY_CONVERTED_GET: `${SOLAR_API_BASE}/converted-inquery/get`,
  INQUERY_CONVERTED_USER_GET: `${SOLAR_API_BASE}/converted-inquery/user/get`,
  INQUERY_CONVERTED_DETAIL: `${SOLAR_API_BASE}/converted-inquery/detail`,
  INQUERY_CONVERTED_FOLLOW_UP_STORE: `${SOLAR_API_BASE}/converted-inquery/follow-up/store`,
  INQUERY_CONVERTED_FOLLOW_UP_UPDATE: `${SOLAR_API_BASE}/converted-inquery/follow-up/update`,
  INQUERY_CONVERTED_FOLLOW_UP_GET: `${SOLAR_API_BASE}/converted-inquery/follow-up/get`,
  INQUERY_CONVERTED_CHANGE_INTEREST_STATUS: `${SOLAR_API_BASE}/converted-inquery/change-interest-status`,
  INQUERY_CONVERTED_ASSIGN_STAFF: `${SOLAR_API_BASE}/converted-inquery/assign-staff`,
  STATES: `${SOLAR_API_BASE}/states`,
  CITIES: (stateId) => `${SOLAR_API_BASE}/cities/${stateId}`,
  STORE: `${SOLAR_API_BASE}/store`,
  VERIFY_OTP: `${SOLAR_API_BASE}/verify-otp`,
  RESEND_OTP: `${SOLAR_API_BASE}/resend-otp`,
  LOGIN: `${SOLAR_API_BASE}/login`,
  DETAIL: `${SOLAR_API_BASE}/detail`,
  UPDATE: `${SOLAR_API_BASE}/update`,
  PROFILE_UPDATE: `${SOLAR_API_BASE}/profile/update`,
  STAFF_PROFILE_UPDATE: `${SOLAR_API_BASE}/staff/profile/update`,
  STAFF_PROFILE_DETAIL: `${STAFF_PROFILE_API_BASE}/detail`,
  USERS: `${SOLAR_API_BASE}/users`,
  BLOG_LIST: `${AUTH_API_BASE}/blog-list?type=property`,
  BLOG_DETAILS: `${AUTH_API_BASE}/blog-details`,
  FORGOT_PASSWORD: `${SOLAR_API_BASE}/forgot-password`,
  CHANGE_PASSWORD: `${SOLAR_API_BASE}/change-password`,
  FORM_OPTIONS: `${SOLAR_API_BASE}/form-options`,
  ROLES_GET: `${SOLAR_API_BASE}/roles`,
  STAFF_STORE: `${SOLAR_API_BASE}/staff/store`,
  STAFF_LOGIN: `${SOLAR_API_BASE}/staff/login`,
  STAFF_CHANGE_PASSWORD: `${SOLAR_API_BASE}/change-password`,
  STAFF_UPDATE: (staffId) => `${SOLAR_API_BASE}/staff/update/${staffId}`,
  STAFF_DELETE: (staffId) => `${SOLAR_API_BASE}/staff/delete/${staffId}`,
  STAFF_ALL: `${SOLAR_API_BASE}/staff/list`,
  SERVICES_STORE: `${SOLAR_API_BASE}/services/store`,
  SERVICES_UPDATE: `${SOLAR_API_BASE}/services/update`,
  SERVICES_DELETE: `${SOLAR_API_BASE}/services/delete`,
  SERVICES_VIEW: `${SOLAR_API_BASE}/services/view`,
  /** POST form-data: `solar_user_id` — list seller services for a user */
  SERVICES_GET_ALL_USER: `${SOLAR_API_BASE}/services`,
  /** GET query: `state_id`, `city_id` (optional) — public catalog; same path as POST but different method */
  SERVICES_CATALOG: `${SOLAR_API_BASE}/services`,
  STAFF_PERMISSION_GET_ALL: `${SOLAR_API_BASE}/permissions`,
  STAFF_PERMISSION_GET_BY_ROLE: `${SOLAR_API_BASE}/permissions/by-role`,
  STAFF_PERMISSION_ASSIGN: `${SOLAR_API_BASE}/permissions/assign`,
  MASTER_STATUS_GET: `${SOLAR_API_BASE}/master/get/status`,
  MASTER_STATUS_STORE: `${SOLAR_API_BASE}/master/store/status`,
  MASTER_STATUS_UPDATE: `${SOLAR_API_BASE}/master/update/status`,
  MASTER_STATUS_CHANGE: `${SOLAR_API_BASE}/master/status-change/status`,
  PROPERTY_STORE: `${SOLAR_API_BASE}/properties/store`,
  PROPERTY_UPDATE: `${SOLAR_API_BASE}/properties/update`,
  PROPERTY_STATUS_CHANGE: `${SOLAR_API_BASE}/properties/status-change`,
  SELLER_DASHBOARD: `${SOLAR_API_BASE}/seller/dashboard`,
  PROPERTY_LIST: `${SOLAR_API_BASE}/properties`,
  PROPERTY_DETAIL: `${SOLAR_API_BASE}/properties/detail`,
  PROPERTY_INQUIRY_LIST: `${SOLAR_API_BASE}/properties/inquiry/get`,
  PROPERTY_INQUIRY_DETAIL: `${SOLAR_API_BASE}/properties/inquiry/detail`,
  PROPERTY_INQUIRY_STATUS_CHANGE: `${SOLAR_API_BASE}/properties/inquiry/status-change`,
  PROPERTY_INQUIRY_FOLLOW_UP_STORE: `${SOLAR_API_BASE}/properties/inquiry/follow-up/store`,
  PROPERTY_INQUIRY_FOLLOW_UP_UPDATE: `${SOLAR_API_BASE}/properties/inquiry/follow-up/update`,
  PROPERTY_INQUIRY_FOLLOW_UP_REPORT: `${SOLAR_API_BASE}/properties/inquiry/follow-up/report`,
  USER_PROPERTY_INQUIRIES: `${SOLAR_API_BASE}/user/inquiries`,
  USER_PROPERTY_INQUIRY_DETAIL: `${SOLAR_API_BASE}/user/inquiry`,
  PACKAGES: `${SOLAR_API_BASE}/packages`,
  PACKAGE_PAYMENT_ORDER: `${SOLAR_API_BASE}/package/payment/order`,
  PACKAGE_PURCHASE: `${SOLAR_API_BASE}/package/purchase`,
  /** Razorpay contract from Razorpay_Developer_API_Requirements Google Doc. */
  PAYMENT_CREATE_ORDER: `${SOLAR_PAYMENT_API_BASE}/create-order`,
  PAYMENT_VERIFY: `${SOLAR_PAYMENT_API_BASE}/verify`,
  PAYMENT_STATUS: (purchaseId) => `${SOLAR_PAYMENT_API_BASE}/status/${purchaseId}`,
};
